import React from 'react'

import { PieOnlyIcon } from '../Icons/PieOnly'

import { Wrap, HeartBeatScale, CenterBlock } from './styled'

export const BeatingPie: React.FC = () => (
  <HeartBeatScale>
    <PieOnlyIcon />
  </HeartBeatScale>
)

export const LoadingBlock: React.FC = () => (
  <CenterBlock>
    <BeatingPie />
  </CenterBlock>
)

export const LoadingScreen: React.FC = () => (
  <Wrap>
    <BeatingPie />
  </Wrap>
)
